import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import productAPI from '../../api/product';
import { Types, Creators } from '../../reducers/product';
import getState from '../../utils/getState';

function* productPersonalizedRequest({ id }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    let data = yield call(productAPI.personalized, id, siteId);

    if (!data.length) {
      data = [];
    }

    yield put(Creators.productPersonalizedSuccess(data));
  } catch (error) {
    yield put(Creators.getProduct({ ...formatError(error), personalized: true }));
  }
}

export default function* watch() {
  yield takeLatest(Types.PRODUCT_PERSONALIZED_REQUEST, productPersonalizedRequest);
}
